import styled from 'styled-components';
import { rem } from 'polished';
import TwoLevelBreadcrumb from '../../../core/TwoLevelBreadcrumb';

const StyledTraining = styled.div`
  width: 100%;
  height: 100%;
  z-index: 3;

  .preload {
    position: relative;
    top: ${rem('80px')};
  }

  .iframe-training {
    border: none;
    position: relative;
    top: ${rem('-75px')};
    z-index: 2;

    &.open {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 40;
    }
  }

  .wrapper-iframe {
    max-width: ${rem('1220px')};
    margin: 0 auto;
    height: 100%;
  }

  .wrapper-pill {
    max-width: ${rem('1220px')};
    margin: ${rem('80px')} auto 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
`;

const StyledTwoLevelBreadcrumb = styled(TwoLevelBreadcrumb)`
  width: 100%;
  margin: ${rem('30px')} 0 0 0;
`;

export { StyledTraining, StyledTwoLevelBreadcrumb };
